import { jsx, jsxs } from "react/jsx-runtime";
import { iconRegistry } from "@pcln/horizon-icons";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/CdnIcon.js";
import { HorizonIcon } from "../HorizonIcon/HorizonIcon.js";
import { buttonVariants } from "./Button.variants.js";
const iconSizes = {
    sm: '20',
    md: '20',
    lg: '24',
    xl: '24'
};
const Button_Button = /*#__PURE__*/ forwardRef(function({ children, disabled, className, iconLeft, iconRight, loading, buttonType = 'button', slots = {
    buttonSlot: '',
    wrapperSlot: '',
    textSlot: '',
    iconSlot: ''
}, ...props }, ref) {
    const { buttonSlot, textSlot, iconSlot, wrapperSlot } = buttonVariants({
        ...props,
        disabled: disabled || loading
    });
    const buttonClasses = cn(buttonSlot(), className, slots.buttonSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const wrapperSlotClasses = cn(wrapperSlot(), slots.wrapperSlot);
    const textSlotClasses = cn(textSlot(), slots.textSlot);
    const iconSize = iconSizes[props.size || 'md'];
    const isIconName = (name)=>'string' == typeof name && Object.hasOwn(iconRegistry, name);
    const getIconComponent = (iconName)=>isIconName(iconName) ? /*#__PURE__*/ jsx(HorizonIcon, {
            className: iconSlotClasses,
            name: iconName,
            size: iconSize
        }) : /*#__PURE__*/ jsx(CdnIcon, {
            className: iconSlotClasses,
            iconName: iconName,
            size: iconSize
        });
    return /*#__PURE__*/ jsx("button", {
        ref: ref,
        type: buttonType,
        className: buttonClasses,
        ...cleanProps(props, Object.keys(buttonVariants.variants)),
        disabled: disabled || loading,
        "aria-busy": loading,
        children: /*#__PURE__*/ jsxs("div", {
            className: wrapperSlotClasses,
            "data-testid": "button-wrapper",
            children: [
                loading && /*#__PURE__*/ jsx(CdnIcon, {
                    className: cn('animate-spin', iconSlotClasses),
                    iconName: "refresh",
                    size: iconSize
                }),
                iconLeft && getIconComponent(iconLeft),
                /*#__PURE__*/ jsx("span", {
                    className: textSlotClasses,
                    children: children
                }),
                iconRight && getIconComponent(iconRight)
            ]
        })
    });
});
export { Button_Button as Button };
